import { Link } from "react-router-dom";
import { Phone, MapPin, Mail, Instagram, Clock } from "lucide-react";
import { BUSINESS, NAV_LINKS } from "@/data/site";

export default function Footer() {
  return (
    <footer
      className="bg-brand-ink text-white pt-20 pb-28 lg:pb-16"
      data-testid="site-footer"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <h2 className="font-display text-4xl md:text-5xl leading-tight">
              Chopstick
              <br />
              <span className="text-brand-gold">Chinese Corner</span>
            </h2>
            <p className="mt-5 max-w-sm text-white/70 leading-relaxed">
              {BUSINESS.tagline} Wok-fired classics and hand-pulled noodles in
              the heart of Sector xxx, Gurugram.
            </p>
            <a
              href={BUSINESS.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-6 inline-flex items-center gap-2 text-sm text-white/80 hover:text-brand-gold transition-colors"
              data-testid="footer-instagram"
            >
              <Instagram size={16} /> Follow us on Instagram
            </a>
          </div>

          <div className="md:col-span-3">
            <h3 className="text-xs uppercase tracking-[0.2em] text-white/50 mb-5">
              Explore
            </h3>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-white/80 hover:text-brand-gold transition-colors"
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h3 className="text-xs uppercase tracking-[0.2em] text-white/50 mb-5">
              Visit us
            </h3>
            <address className="not-italic space-y-4 text-white/80">
              <p className="flex items-start gap-3">
                <MapPin size={18} className="mt-0.5 text-brand-gold shrink-0" />
                <span>
                  {BUSINESS.addressLine1}
                  <br />
                  {BUSINESS.addressLine2}, {BUSINESS.addressRegion}
                </span>
              </p>
              <p className="flex items-center gap-3">
                <Phone size={18} className="text-brand-gold shrink-0" />
                <a href={`tel:${BUSINESS.phoneHref}`} className="hover:text-brand-gold transition-colors">
                  {BUSINESS.phoneDisplay}
                </a>
              </p>
              <p className="flex items-center gap-3">
                <Mail size={18} className="text-brand-gold shrink-0" />
                <a href={`mailto:${BUSINESS.email}`} className="hover:text-brand-gold transition-colors">
                  {BUSINESS.email}
                </a>
              </p>
              <p className="flex items-start gap-3">
                <Clock size={18} className="mt-0.5 text-brand-gold shrink-0" />
                <span>{BUSINESS.hoursShort}</span>
              </p>
            </address>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <p>© {new Date().getFullYear()} {BUSINESS.name}. All rights reserved.</p>
          {BUSINESS.isPlaceholder && (
            <p className="text-brand-gold-soft/80">
              Note: contact details shown are placeholders pending final confirmation.
            </p>
          )}
        </div>
      </div>
    </footer>
  );
}
